import { _ } from "../polyglot/polyglot.js";
import ImporterFactory from "../newWizard/import/ImporterFactory.js";

/**
 * `importerDocumentGenerator` is a function taking an abstract
 * document class as parameter and return a new document class
 * subclassing the parameter.
 *
 * @param {object} importWizardDocument - The abstract document class to
 *   subclass
 */
export default function importerDocumentGenerator(importWizardDocument) {
	return importWizardDocument.subclass((that, my) => {
		my.initialize = function ({ integrationType, name }) {
			my.super(...arguments);

			my.ImporterClass =
				ImporterFactory.instance().findClassFromIntegrationType(
					integrationType,
				);

			that.title = _("Import from {name}", { name });
			that.showUpdating();
		};

		my.renderUpdatingContentOn = function (html) {
			html.h2(
				{ klass: "import-loading-message" },
				my.ImporterClass.loadingMessage(),
			);

			my.super(...arguments);
		};

		my.renderContentOn = function (html) {
			html.div(
				{ klass: "import-wizard" },
				my.importWidget.getRenderable(),
			);
		};

		my.createImportWidget = function () {
			return new my.ImporterClass();
		};

		my.startWizard = function () {
			my.importWidget.start(that.showContent);
		};
	});
}
